import type { EntityConfig } from "../hooks/useEntity";

export const documentEntityConfig: EntityConfig = {
  name: "Document",
  orderBy: "updated_at DESC",
  properties: {
    title: { type: "string", description: "Document title" },
    content: { type: "string", description: "Document content in HTML format" },
    paperFormat: {
      type: "string",
      enum: ["APA", "MLA", "Chicago", "CSE", "Harvard", "Turabian", "AMA", "IEEE"],
      description: "Academic paper format style",
    },
    userId: { type: "integer", description: "Owner user ID" },
    topic: { type: "string", description: "Main topic of the paper" },
    wordCount: { type: "integer", description: "Current word count" },
    aiUsagePercentage: { type: "number", description: "Percentage of AI-generated content" },
    lastEditedAt: { type: "string", format: "date-time", description: "Last edit timestamp" },
    collaborators: { type: "string", description: "JSON array of collaborator user IDs" },
    notebookId: {
      type: "string",
      description: "Class notebook identifier the draft belongs to",
    },
    notebookClassTitle: {
      type: "string",
      description: "Human readable notebook label (e.g., SOC 402)",
    },
    notebookTabId: {
      type: "string",
      description: "Notebook tab identifier where the draft originated",
    },
    notebookTabLabel: {
      type: "string",
      description: "Notebook tab label shown in the UI",
    },
    notebookDraftId: {
      type: "string",
      description: "Stable draft token used to reopen organizer-linked papers",
    },
    thesisStatement: {
      type: "string",
      description: "Latest saved thesis statement for this draft",
    },
    isProtected: {
      type: "boolean",
      description: "Whether the document is password-protected with encryption",
    },
  },
  required: ["title", "content", "userId"],
};
